/** This file is auto generated by convertSvgToJsx.ts */

import type { IconSVGProps } from '../../components/icon/Icon'
const attachment = (props?: IconSVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m15.25 11.162-4.879-5.01A2.96 2.96 0 0 0 8.25 5.25a2.96 2.96 0 0 0-2.121.902 3.123 3.123 0 0 0-.879 2.179c0 .817.316 1.6.879 2.178l4.007 4.114a2 2 0 0 0 .649.46 1.954 1.954 0 0 0 2.204-.434 2.101 2.101 0 0 0-.025-2.93L8.957 7.603a.986.986 0 0 0-.703-.289.987.987 0 0 0-.699.3 1.04 1.04 0 0 0-.293.718c-.002.27.099.529.28.722l4.008 4.116M6.25 15H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.848a1 1 0 0 1 .761.352L9.587 2.5"
    />
  </svg>
)
export default attachment
